// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"67c6152b","176":"971ee1e4","288":"93c0a2b0","317":"5a6c4ee3","326":"db864ad9","345":"7fbcd959","348":"9bd8f303","453":"0d013eee","566":"40fce195","577":"78e7795d","638":"8f4f61d1","737":"f1273e25","999":"ef5f2383"}[chunkId] + ".chunk.js";
};